<template>
  <div class="p-container">
    <uploader type="turbine" @upload="uploadSuccess"></uploader>
    <div class="title-box">
      <div class="search-box">
        <el-input
          placeholder="机组型号、关键字"
          class="input-with-select"
          size="medium"
          v-model="keyword"
          @focus="searchFocus()"
          @keyup.enter.native="searchTo()"
        >
          <el-button
            @click="searchTo()"
            :loading="tableLoading"
            slot="append"
            icon="el-icon-search"
            title="搜索"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="table-box">
      <el-table
        :data="turbineList"
        @select="handleSelectionChange"
        @select-all="handleSelectAllChange"
        v-loading="tableLoading"
        key="1"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="typeName" label="机型名字"></el-table-column>
        <el-table-column prop="vendor" label="厂商">
          <template slot-scope="scope">
            <span>{{ scope.row.vendor === 0 ? '东方电气' : '其它厂家' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="delTurbine(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="select-del"
      style="margin-top: 10px"
      v-if="checkedList.length > 0"
    >
      <el-button type="danger" @click="delTurbine(false)">删除</el-button>
    </div>
  </div>
</template>

<script>
import Uploader from './components/uploader';
export default {
  components: {
    Uploader
  },
  data() {
    return {
      turbineList: [],
      keyword: '',
      tableLoading: false,
      checkedList: []
    };
  },
  watch: {},
  async mounted() {
    await this.getTurbineList();
  },
  methods: {
    searchFocus() {},
    uploadSuccess(val) {
      if (val) {
        this.getTurbineList();
      }
    },
    async searchTo() {
      await this.getTurbineList();
    },
    async getTurbineList() {
      this.tableLoading = true;
      try {
        const { data } = await this.$fetch(
          '/windfarm/turbineType/getTurbineOrPowerCurveMenu',
          {
            params: {
              keyword: this.keyword
            },
            showError: true
          }
        );
        this.turbineList = data.menu;
        this.tableLoading = false;
        return {
          data: data.menu
        };
      } catch (e) {
        this.tableLoading = false;
        throw e;
      }
    },
    async delTurbine(row) {
      let params = {};
      if (!row) {
        params.turbineTypeIds = this.checkedList
          .map(item => {
            return item.turbineTypeId;
          })
          .join(',');
      } else {
        params.turbineTypeIds = row.turbineTypeId.toString();
      }
      //console.log(params);
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          await this.$fetch(
            '/windfarm/turbineType/delTurbineOrPowerCurveMenu',
            {
              params,
              showLoading: true,
              showError: true,
              showSuccess: true
            }
          );
          await this.getTurbineList();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleSelectionChange(val) {
      this.checkedList = val;
    },
    handleSelectAllChange(val) {
      this.checkedList = val;
    }
  }
};
</script>

<style lang="less" scoped>
.p-container {
  padding: 20px;
  .title-box {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .select {
      .el-dropdown-link {
        cursor: pointer;
        color: #dcdee5;
        font-size: 20px;
      }
      .el-icon-arrow-down {
        font-size: 20px;
      }
    }
    .search-box {
      .input-with-select {
        width: 400px;
      }
    }
  }
}
</style>
